import axios from "axios";
import * as mutationTypes from "../mutation-types";
import { WINNERS_RUBRICS_API_URL, WINNERS_NOMINEES_API_URL } from "../../constants/urls";
import { Nomination } from "./nominations";

export default function () {
  const state = {
    nomination: null,
    nominations: [],
    nominees: [],
    path: null,
  };

  const actions = {
    setCurrentPath({ commit }, path) {
      commit("path", path);
    },

    setNomination({ commit }, nomination) {
      commit(mutationTypes.SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS, nomination);
    },

    loadNominees({ commit, dispatch, state }, params) {
      const host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });

      const url = `${host + WINNERS_NOMINEES_API_URL}${state.nomination.id}/`;

      axios
        .get(url, { withCredentials: true })
        .then((result) => {
          commit("loadNominees", result.data);

          dispatch("loader/decrement", {}, { root: true });
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          dispatch("loader/decrement", {}, { root: true });
        });
    },

    loadNominations({ commit, dispatch, state }, params) {
      const host = this.state.context.host;
      dispatch("loader/increment", {}, { root: true });

      let currentYear = "";

      if (params && params.year) {
        currentYear = "?year=" + params.year;
      }

      const url = host + WINNERS_RUBRICS_API_URL + currentYear;

      axios
        .get(url, { withCredentials: true })
        .then(({ data: nominations }) => {
          commit(mutationTypes.FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS, nominations);

          if (state.path !== null) {
            const currentNomination = nominations.find((nomination) => {
              if (state.path.indexOf(nomination.link) !== -1) {
                return nomination;
              }

              return undefined;
            });

            commit(
              mutationTypes.SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS,
              currentNomination
            );
          }

          dispatch("loader/decrement", {}, { root: true });
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
          dispatch("loader/decrement", {}, { root: true });
        });
    },

    setNominationByPath({ commit, state }, path) {
      const currentNomination = state.nominations.find((nomination) => {
        if (path.indexOf(nomination.link) !== -1) {
          return nomination;
        }

        return undefined;
      });

      commit(mutationTypes.SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS, currentNomination);
    },

    setYearByPath({ commit, state }, path) {
      const year = state.nominations.find((nomination) => {
        if (path.indexOf(nomination.link) !== -1) {
          return nomination;
        }

        return undefined;
      });

      commit(mutationTypes.SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS, year);
    },
  };

  const mutations = {
    [mutationTypes.SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS](state, value) {
      state.nomination = value;
    },

    [mutationTypes.FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS](state, value) {
      state.nominations = value;
    },

    path(state, value) {
      state.path = value;
    },

    loadNominees(state, value) {
      state.nominees = value;
    },
  };

  const getters = {
    nomination({ nomination }) {
      return nomination;
    },

    nominations({ nominations = [] }) {
      return nominations.map((nomination) => new Nomination(nomination));
    },

    nominees({ nominees }) {
      return nominees;
    },
  };

  return {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
  };
}



// WEBPACK FOOTER //
// ./src/store/modules/archive.js